import type { Session } from 'api';
import { useTranslation } from 'i18n';
import { Suspense } from 'react';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, CenteredLoader, Typography } from 'ui';
import { ExpandMore } from 'ui/icons';

import { EvidenceAiSessionDetails } from '../EvidenceAiSessionDetails/EvidenceAiSessionDetails';
import { EvidenceSessionSummary } from '../EvidenceSessionSummary/EvidenceSessionSummary';
import { SessionEditDialog } from '../SessionEditDialog/SessionEditDialog';

export const EvidenceAiSession = ({
  session,
  defaultExpanded = false,
  siteMaterialId,
}: {
  defaultExpanded?: boolean;
  session: Session;
  siteMaterialId: number;
}) => {
  const { t } = useTranslation('features');
  const { date, uploaded_by, parent_content_type_id, parent_id, origin } = session;

  return (
    <Accordion defaultExpanded={defaultExpanded} variant="outlined">
      <AccordionSummary expandIcon={<ExpandMore />} data-testid="evidence-ai-session-summary">
        <EvidenceSessionSummary
          date={date}
          uploadedBy={uploaded_by}
          origin={origin}
          showAIChip={true}
          showSelfServeChip={session.is_self_serve}
        />
      </AccordionSummary>
      <AccordionDetails>
        {parent_content_type_id && parent_id ? (
          <Suspense fallback={<CenteredLoader />}>
            <EvidenceAiSessionDetails
              date={date}
              parentContentTypeId={parent_content_type_id}
              parentId={parent_id}
              uploadedById={uploaded_by?.id || null}
              siteMaterialId={siteMaterialId}
            />
          </Suspense>
        ) : (
          <Typography>{t('backlog.common.noData')}</Typography>
        )}
      </AccordionDetails>
      {!session.is_self_serve ? (
        <AccordionActions>
          <SessionEditDialog
            date={date}
            parentContentTypeId={parent_content_type_id}
            parentId={parent_id}
            uploadedById={uploaded_by?.id || null}
          />
        </AccordionActions>
      ) : null}
    </Accordion>
  );
};
